export const greenDark = "#33A39E";
export const greenMiddle = "#a8dedd";

export const grayLight = "#CECECE";
export const grayDark = "#A9ACB2";

export const redMiddle = "#db3737";

export const black = "#28303F";
